import { notification, Alert } from 'antd';
import React, { useState, useEffect } from 'react';

import GiftCodeTable from '@/GiftCode/components/GiftCodeTable';
import SaveSpreadsheetGiftCodeTable from '@/GiftCode/components/SaveSpreadsheetGiftCodeTable';
import SpreadsheetUrlInput from '@/GiftCode/components/SpreadsheetUrlInput';
import { fetchSpreadsheetGiftCodeData } from '@/GiftCode/service/spreadsheetAccessor';
import { useGacha } from '@/hooks/context/GachaContext';
import { GiftCode } from '@/models/GiftCode';

const isValidSpreadsheetNewGiftCodes = (spreadsheetNewGiftCodes: GiftCode[]): boolean => {
  if (
    spreadsheetNewGiftCodes.filter((spreadsheetNewGiftCode) => Number.isNaN(spreadsheetNewGiftCode.price)).length > 0
  ) {
    notification.error({ message: '金額が不正なギフトコードがあったので読み込みに失敗しました。' });
    return false;
  }

  if (spreadsheetNewGiftCodes.filter((spreadsheetNewGiftCode) => !spreadsheetNewGiftCode.code).length > 0) {
    return false;
  }

  return true;
};

const AddGiftCode: React.FC<{}> = () => {
  const { gacha } = useGacha();

  const [spreadsheetUrl, setSpreadsheetUrl] = useState<string>('');
  const [spreadsheetGiftCode, setSpreadsheetGiftCode] = useState<GiftCode[]>([]);
  const [addedGiftCodes, setAddedGiftCodes] = useState<GiftCode[]>([]);

  useEffect(() => {
    if (!spreadsheetUrl) {
      return;
    }

    fetchSpreadsheetGiftCodeData(spreadsheetUrl, gacha.name).then((response) => {
      const spreadsheetNewGiftCodes = response.filter((res) => !res.isLoaded);
      if (!spreadsheetNewGiftCodes || spreadsheetNewGiftCodes.length < 1) {
        notification.info({
          message: '新しいギフトコードはありませんでした',
        });

        return;
      }

      if (!isValidSpreadsheetNewGiftCodes(spreadsheetNewGiftCodes)) {
        return;
      }

      setSpreadsheetGiftCode(response);
    });
  }, [spreadsheetUrl]);

  return (
    <div>
      <SpreadsheetUrlInput setSpreadsheetUrl={setSpreadsheetUrl} />
      <SaveSpreadsheetGiftCodeTable
        spreadsheetUrl={spreadsheetUrl}
        spreadsheetGiftCodes={spreadsheetGiftCode}
        setAddedGiftCodes={setAddedGiftCodes}
      />

      {addedGiftCodes && addedGiftCodes.length > 0 && (
        <div>
          <Alert type="success" message="以下のギフトコードの追加に成功しました" />
          <GiftCodeTable giftCodes={addedGiftCodes} />
        </div>
      )}
    </div>
  );
};

export default AddGiftCode;
